import React from 'react'
import { Helmet } from 'react-helmet'
import Footer from '../components/Footer'
import Navbar from '../components/Navbar'
import '../css/index.css'
import useSiteMetadata from './SiteMetadata'
import { withPrefix } from 'gatsby'
if (typeof window !== 'undefined') {
  // eslint-disable-next-line global-require
  // @ts-ignore
  require('smooth-scroll')('a[href*="#"]')
}
const TemplateWrapper = ({ children }) => {
  const { title, description } = useSiteMetadata()

  return (
    <>
      <Helmet>
        <html lang="en" />
        <title>{title}</title>
        <meta name="description" content={description} />

        {/* <link
          rel="apple-touch-icon"
          sizes="180x180"
          href={`${withPrefix('/')}img/apple-touch-icon.png`}
        /> */}
        <link
          rel="icon"
          type="image/png"
          href={`${withPrefix('/')}img/favicon-32x32.png`}
          sizes="32x32"
        />
        <link
          rel="icon"
          type="image/png"
          href={`${withPrefix('/')}img/favicon-16x16.png`}
          sizes="16x16"
        />

        {/* <link
          rel="mask-icon"
          href={`${withPrefix('/')}img/safari-pinned-tab.svg`}
          color="#ff4400"
        /> */}
        <meta name="theme-color" content="#800000" />

        <meta property="og:type" content="business.business" />
        <meta property="og:title" content={title} />
        {/* <meta property="og:url" content="https://www.kdlanguageservices.co.za/" /> */}
        <meta
          property="og:image"
          content="https://www.kdlanguageservices.co.za/img/share_image.png"
        />
        <meta
          property="og:description"
          content={description}
        />
      </Helmet>
      <Navbar />
      <div>{children}</div>
      <Footer />
    </>
  )
}

export default TemplateWrapper
